export default __webpack_public_path__ + "static/savings-type-rainy-77b276e98db9ebebbb974045acf7d722.png";